import { render, staticRenderFns } from "./CreateTrafiklabWidgetModal.vue?vue&type=template&id=050980a1&scoped=true"
import script from "./CreateTrafiklabWidgetModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTrafiklabWidgetModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateTrafiklabWidgetModal.vue?vue&type=style&index=0&id=050980a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050980a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050980a1')) {
      api.createRecord('050980a1', component.options)
    } else {
      api.reload('050980a1', component.options)
    }
    module.hot.accept("./CreateTrafiklabWidgetModal.vue?vue&type=template&id=050980a1&scoped=true", function () {
      api.rerender('050980a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/trafiklab/CreateTrafiklabWidgetModal.vue"
export default component.exports